module.exports = __webpack_public_path__ + "media/polianak.fc72661c.mp3";